module.exports = "<div (clickOutside)=\"close()\" [class]=\"direction\">\n  <div class=\"opener\" (click)=\"toggle()\">\n    <ng-content select=\"[balloon-opener]\"></ng-content>\n  </div>\n  <div class=\"body zi10000\" [hidden]=\"isHidden\" [@toggleAnimation]=\"animationStep\">\n    <div class=\"content\">\n      <ng-content></ng-content>\n    </div>\n    <div class=\"corner\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /srv/projects/jsapp/src/app/shared/balloon/balloon.component.html
// module id = ZZ+n
// module chunks = 6